import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import Workbook from 'vendor/react-excel-workbook';
import {calculateProgramArea, formatDollarCommas} from 'common/utils';
import REST from 'go/requests/rest';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

export const getExportData = (taskData) => {
  let exportData = _.map(taskData, (task) => {
    let staticData = _.get(task, 'static', '{}');
    return {
      ...task,
      ...staticData,
    };
  });
  return exportData;
};

export const getCode = (type, refData) => {
  let code = '';
  _.forEach(refData, (ref) => {
    if (_.get(ref, 'id') == type) {
      code = _.get(ref, 'code');
    }
  });
  return code;
};

export const addAppShare = (appShare) => {
  let total = 0;
  if (appShare) {
    const arr = JSON.parse(appShare);
    total += arr.reduce((total, number) => total + +number, 0);
  }
  return total;
};

export const parseAmount = (value) => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  const amount = Number(String(value).replace(/,/g, ''));
  return isNaN(amount) ? 0 : amount;
};

// The passthrough congressional table names the federal share totalFedShare;
// every other one names it fedShare.
export const getFedShare = (row) => row.totalFedShare ?? row.fedShare;

export const calcTPC = (row) => {
  let totalAppShare = addAppShare(row.subGrantAppShare);
  let totalFedShare = parseAmount(getFedShare(row));
  let total = row.subGrantAppShare
    ? formatDollarCommas(totalAppShare + totalFedShare + '')
    : row.totalProjectCost;
  return total;
};

export const getDescription = (type, refData) => {
  let description = '';
  _.forEach(refData, (ref) => {
    if (_.get(ref, 'id') == type) {
      description = _.get(ref, 'description');
    }
  });
  return description;
};

export const parseArray = (value) => {
  return value ? JSON.parse(value).join(', ') : null;
};

export const CongressionalWorkBook = ({exportRef, taskData}) => {
  const exportData = getExportData(taskData);
  const [refData, setRefData] = useState([]);

  useEffect(() => {
    REST.ref
      .getCodelist('APPLICATION_TYPE')
      .then((response) => forceJsonResponse(response, MONO))
      .then((res) => {
        setRefData(_.get(res, 'APPLICATION_TYPE', []));
      })
      .catch((error) => {
        console.error('error');
      });
  }, []);

  return (
    <Workbook
      filename="CongressionalNotification.xlsx"
      element={<span ref={exportRef} />}
    >
      <Workbook.Sheet data={exportData} name="Dashboard Sheet">
        <Workbook.Column label="Program Name" value="programName" />
        <Workbook.Column label="Disaster Number" value="disasterNumber" />
        <Workbook.Column label="Award Number" value="awardNumber" />
        <Workbook.Column
          label="Amount of Federal Share"
          value={(row) => getFedShare(row)}
        />
        <Workbook.Column label="Total Project Cost" value={(row) => calcTPC(row)} />
        <Workbook.Column
          label="Federal Share Percentage"
          value={(row) => parseArray(row.federalSharePercentage)}
        />
        <Workbook.Column label="Organization Name" value="organizationName" />
        <Workbook.Column label="Physical City" value="organizationCity" />
        <Workbook.Column label="Physical State" value="organizationState" />
        <Workbook.Column label="Program Description" value="programDescription" />
        <Workbook.Column label="Physical Address" value="organizationAddress" />
        <Workbook.Column
          label="Physical ZipcodeExt+4"
          value={(row) =>
            row.organizationZipExt
              ? `${row.organizationZip}-${row.organizationZipExt}`
              : row.organizationZip
          }
        />
        <Workbook.Column
          label="Category"
          value={(row) =>
            `${
              row.disasterFlag === 'true'
                ? getCode(row.applicationType, refData)
                : getDescription(row.applicationType, refData)
            }`
          }
        />
        <Workbook.Column label="Brief Summary" value="briefSummary" />
        <Workbook.Column label="Eligible for SFM" value="eligibleForSFM" />
        <Workbook.Column label="Group" value="congressionalNotificationGroupName" />
      </Workbook.Sheet>
    </Workbook>
  );
};
export default CongressionalWorkBook;
